
const featuredVideoBreakpoint = window.matchMedia('(max-width: 768px)');
const announcementHeightSection2 = document.querySelector('#shopify-section-annoucement-bar');
const headerSection2 = document.querySelector('#shopify-section-MM-Header');
let headerHeight2 = headerSection2.clientHeight;
if(announcementHeightSection2 || headerSection2) {
  headerHeight2 = headerSection2.clientHeight + announcementHeightSection2.clientHeight;
  document.body.style.setProperty('--static-header-height', `${(headerHeight2)}px`);
}
const featuredVideos = document.querySelectorAll('.js-featured-video video');
function playFeaturedVideo() {
  if(featuredVideos) {
    featuredVideos.forEach(vid => {
      let videoSrc = vid.closest('.js-featured-video').dataset.videoUrl;
      if(featuredVideoBreakpoint.matches) {
        videoSrc = vid.closest('.js-featured-video').dataset.videoMobileUrl;
      }
      vid.querySelector('source').src = videoSrc;
      vid.load();
      setTimeout(() => {
        vid.muted = true;
        vid.controls = true;
        vid.style.visibility = 'visible';
        vid.style.opacity = 1;
        vid.autoplay = true;
        vid.play();
      }, 100);
    })
  }
}

function stopFeaturedVideo() {
  if(featuredVideos) {
    featuredVideos.forEach(vid => {
      vid.pause();
      vid.currentTime = 0;
      vid.autoplay = false;
    })
  }
}

let startVideoPosition = '50% bottom';
let endVideoPosition = {
  end: `center ${headerHeight2}`
};
ScrollTrigger.create({
  trigger: '.js-featured-video',
  start: startVideoPosition,
  ...endVideoPosition,
  scrub: .5,
  onEnter: () => {
    playFeaturedVideo();
  },
  onLeave: () => stopFeaturedVideo(),
  onEnterBack: () => {
    playFeaturedVideo();
  },
  onLeaveBack: () => stopFeaturedVideo()
});